import React, { Component } from 'react'
import MetaTags from 'react-meta-tags';


class MetaTagsComponent extends Component {
	constructor(props) {
		super(props)
	}
	render() {
		return (
			<MetaTags>
				<title>{this.props.title}</title>
				<meta name="description" content={this.props.description} />

				<meta name="twitter:card" content={this.props.twitterCard} />
				<meta name="twitter:site" content={this.props.twitterSite} />
				<meta name="twitter:creator" content={this.props.twitterCreator} />

				<meta name="og:title" content={this.props.ogTitle} />
 				<meta name="og:description" content={this.props.ogDescription} />
 				<meta name="og:image" content={this.props.ogImage} />
 				<meta name="og:type" content={this.props.ogType} />
 				<meta name="og:site_name" content={this.props.ogSiteName} />
 				<meta name="og:locale" content={this.props.ogLocale} />
 				<meta name="og:url" content={this.props.ogURL} />
			</MetaTags>
		);
	}
}

export default MetaTagsComponent



// WEBPACK FOOTER //
// ./src/components/MetaTags.js